import React, { ReactHTML } from "react";
import RegistrationContainer from "../../containers/RegistrationContainer/RegistrationContainer";
import Page from "../Page/Page";

type PageProps = {
    // user : any;
    whatever: string;
};
export default function RegistrationPage(props: PageProps) {
    
    return (
        <>
        <div> 
            <RegistrationContainer></RegistrationContainer>        
        </div>
       
       
        </>
    )
}
